import axios from "axios"
import store from "@/store/index"

const api = axios.create()

api.interceptors.request.use(
  (config) => {
    const authStore = store.state.authStore

    if (authStore.isAuthenticated && authStore.user.access_token) {
      config.headers.Authorization = `Bearer ${authStore.user.access_token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default api
